// extracted by mini-css-extract-plugin
export default {"component":"zkB2W"};